/**
 * Scripts for read more functionality
 * See template usage example in testimonial-slider
 */

 jQuery(".read-more-toggle").on('click',function(e) {
     e.preventDefault();
     var readMore = jQuery(this).closest('.content-with-read-more');

     if (readMore.hasClass('expanded')) {
       readMore.removeClass('expanded');
     } else {
       readMore.addClass('expanded');
     }
 });
